import React from 'react';
import { Plus, Download, Trophy, Zap, Target, Star, Trash2 } from 'lucide-react';
import StatsCard from './StatsCard';
import ExportMenu from './ExportMenu';

const Header = ({
  showForm,
  setShowForm,
  showExportMenu,
  setShowExportMenu,
  questions,
  stats,
  achievement,
  streak,
  onClearAll
}) => {
  return (
    <div className="header">
      <div className="header-content">
        <div>
          <h1 className="header-title">🎯 DSA Tracker</h1>
          <p className="header-subtitle">Master Data Structures &amp; Algorithms</p>
        </div>
        <div className="header-actions">
          <button
            onClick={() => setShowForm(!showForm)}
            className="btn btn-primary"
          >
            <Plus size={20} />
            Add Problem
          </button>
          <div style={{ position: 'relative' }}>
            <button
              onClick={() => setShowExportMenu(!showExportMenu)}
              className="btn btn-success"
            >
              <Download size={20} />
              Export
            </button>
            {showExportMenu && (
              <ExportMenu
                questions={questions}
                onClose={() => setShowExportMenu(false)}
              />
            )}
          </div>
          {stats.total > 0 && (
            <button
              onClick={onClearAll}
              className="btn btn-danger"
              title="Clear all data"
            >
              <Trash2 size={20} />
            </button>
          )}
        </div>
      </div>
      <div className="stats-grid">
        <StatsCard
          icon={Trophy}
          title="Achievement"
          value={`${achievement.icon} ${achievement.level}`}
          className={achievement.color}
        />
        <StatsCard
          icon={Zap}
          title="Streak"
          value={`${streak} days 🔥`}
          className="achievement-legend"
        />
        <StatsCard
          icon={Target}
          title="Solved"
          value={`${stats.attempted}/${stats.total}`}
          className="achievement-advanced"
        />
        <StatsCard
          icon={Star}
          title="Favorites"
          value={`${stats.starred} ⭐`}
          className="achievement-legend"
        />
      </div>
    </div>
  );
};

export default Header;